import UserStatusCongratulations from '../../UserStatus/UserStatusCongratulations/UserStatusCongratulations';
import DesktopPopup from '../../../components/DesktopPopup/DesktopPopup';
import { Modal } from 'react-bootstrap';
import useCloseLocation from '../../Location/hooks/useCloseLocation';
import { LOCATION_COMPONENTS_SEARCH_PARAMS, LOCATION_NAMES } from '../../Location/locationConstants';

function StatusCongratulationsModal() {
    const handleClose = useCloseLocation({
        locationName: LOCATION_NAMES.STATUS_CONGRATULATIONS,
        typeLocation: LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL,
    });

    return <Modal show
                  onHide={handleClose}
                  centered
                  size={'lg'}>
        <DesktopPopup onClose={handleClose} show={true} size={'lg'} contentClassName={'overflow-visible'}>
            <UserStatusCongratulations/>
        </DesktopPopup>
    </Modal>;
}

export default StatusCongratulationsModal;
